export default __webpack_public_path__ + "5f67c40c9cd5f642f65e7b2f11f3770e.svg";